<template lang="pug">
  .container
    .row
      .column
        .card.p-2
          label Recipient info
          textarea(rows="5", v-model="recipient_info")

        template(v-for="header in headers")
          .card.p-2
            label {{header}}
            button.button(@click="addField(header)") Add new info
            template(v-for="(info,index) in body[header]")
              .row
                .column
                  label Title
                    input(type="text" v-model="info.title")
                .column
                  label Value
                  .input-group
                    input.input-group-field(type="text" v-model="info.value")
                    .input-group-button
                      button.button.fa.fa-times(@click="()=>{body[header].splice(index,1)}")
      .column.card.p-2
        label Description
        Editor(v-model="body.text")

        label prev_next_reservations
          input(type="number", min="0", v-model="body.prev_next_reservations")
        ActionButton(:action="save", :disabled="recipient_info === '' || body.text === ''") Generate pdf
    .row.column


</template>

<script>
import ArrayEdit from "../../../components/structure/ui/ArrayEdit";
import Editor from "../../../components/structure/ui/Editor";
import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
import ActionButton from "../../../components/structure/ui/ActionButton";

export default {
  name: "ReportReservation",
  components: {ActionButton, Editor, ArrayEdit},
  data() {
    return {
      headers: ['document_info', 'header_info'],
      recipient_info: "",
      body: {
        text: "",
        recipient_info: [],
        document_info: [
          {title: "ID", value: this.$route.params.id},
        ],
        header_info: [],
        prev_next_reservations: 0,
      },
    }

  },
  methods: {
    addField(data) {
      this.body[data].push({title: "", value: ""})
    },
    save() {
      this.body.recipient_info = this.recipient_info.split("\n")

      return KeplerBackofficeSdk.reservations.select(this.$route.params.id).report(this.body, (response) => {
window.open(response,'_blank')
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ReportReservation.vue?0d557b7e